import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import FeatureTogglz from '@bibliocommons/feature-togglz';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import Divider from '@bibliocommons/divider';
import Heading from '@bibliocommons/heading';

import MoreFromNovelist from 'app/components/bibs/shared/MoreFromNovelist';
import { CommunityTagsContainer } from './CommunityTags';
import RelatedTitles from './RelatedTitles';
import SimilarSeries from './SimilarSeries';
import SimilarAuthors from './SimilarAuthors';
import RelatedAuthors from './RelatedAuthors';
import { OnlineResourcesContainer } from './OnlineResources';

import './Explore.scss';

export default class Explore extends React.PureComponent {
  render() {
    const {
      catalogBib,
      tags,
      authorSuggestions,
      relatedTitles,
      relatedAuthors,
      onlineResources,
      handleRelatedTitleClick,
      trackRelatedAuthorClick,
      trackSimilarAuthorClick
    } = this.props;
    const metadataId = catalogBib.get('metadataId');
    if (!tags.size && !authorSuggestions.size && !relatedTitles.size && !relatedAuthors.size && !onlineResources.size) {
      return null;
    }

    return (
      <div>
        <section className="cp-bib-explore container">
          <div className="row">
            <div className="col-lg-3">
              <Heading tagName="h2" size="moderate" variant>
                <FormattedMessage id="explore_section" />
              </Heading>
            </div>
            <div className="col-lg-7">
              <RelatedTitles handleRelatedTitleClick={handleRelatedTitleClick} />
              <OnlineResourcesContainer metadataId={metadataId} />
              <CommunityTagsContainer metadataId={metadataId} />
              <FeatureTogglz>
                {features => (features.get(TOGGLZ_FEATURES.NERF_BIB_PAGE_DEVELOPMENT) ? <SimilarSeries /> : null)}
              </FeatureTogglz>
              {authorSuggestions.size || relatedAuthors.size ? (
                <div className="more-authors">
                  <SimilarAuthors authorSuggestions={authorSuggestions} trackClick={trackSimilarAuthorClick} />
                  <RelatedAuthors relatedAuthors={relatedAuthors} trackClick={trackRelatedAuthorClick} />
                </div>
              ) : null}
              <MoreFromNovelist
                catalogBib={catalogBib}
                heading={
                  <Heading tagName="h3" size="medium" variant>
                    <FormattedMessage id="more_about_this_title" />
                  </Heading>
                }
              />
            </div>
          </div>
        </section>
        <div className="container">
          <Divider />
        </div>
      </div>
    );
  }
}

Explore.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  trackRelatedAuthorClick: PropTypes.func.isRequired,
  trackSimilarAuthorClick: PropTypes.func.isRequired,

  // Props below are used to conditionally render section title
  tags: ImmutablePropTypes.list.isRequired,
  relatedTitles: ImmutablePropTypes.list.isRequired,
  authorSuggestions: ImmutablePropTypes.list.isRequired,
  relatedAuthors: ImmutablePropTypes.list.isRequired,
  onlineResources: ImmutablePropTypes.list.isRequired,
  handleRelatedTitleClick: PropTypes.func
};
